import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { HolidayRange } from 'app/shared/models/request/holiday/range-holiday.class';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { AppConfig } from 'app/app.config';
import { ValidatorService } from 'app/shared/services/validator.service';
import { Observable, Subject } from 'rxjs';
import { ISelect } from 'app/shared/models/select.model';
import { HolidayService } from '../holiday.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SecurityService } from 'app/shared/services/security.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { IDtoEmployeeFilter } from 'app/shared/models/request/holiday/dto-employee-filter.model';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { IDtoHoliday } from 'app/shared/models/request/holiday/dto-holiday.model';
import { IDtoHistory } from 'app/shared/models/request/holiday/dto-history.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from '../../security/identity.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { CustomerService } from '../../quote/customer.service';
import { map } from 'rxjs/operators';
import { PayrollService } from '../../payroll.service';
import { IDtoPayroll } from 'app/shared/models/payroll/dto-payroll.model';
import { TH } from 'angular-mydatepicker';
import { IDtoPeriod } from 'app/shared/models/payroll/dto-period.model';
@Component({
    selector: 'app-holiday-request',
    styleUrls: ['holiday-request.style.scss'],
    templateUrl: 'holiday-request.template.html'
})
export class HolidayRequestComponent implements OnDestroy, OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private flag = false;
    private errorMessages: any;
    /**Variables */
    public nav: any;
    private eventFormatted = false;
    private showRoles: any;
    /**Formularios */
    private formHoliday: FormGroup;
    /**Catalogos */
    private catalogEmployees: ISelect[];
    private catalogEmployeesTemp: ISelect[];
    private catalogTrademarks: Observable<IDtoCatalog[]>;
    /**Listas */
    private listHolidayRequests: IDtoHoliday[] = [];
    private listHolidayLaborOlds: IDtoHistory[] = [];
    @ViewChild('addSwal', { static: false }) private addSwal: SwalComponent;
    private rangeHoliday = new HolidayRange(null, 0, new Date(), new Date(), null);
    private zones: any;
    private marks: any;
    private employee = {} as IDtoEmployee;
    private employeeIniId: string;
    private festiveDays: ISelect[];
    private minDate: Date;
    private period = {} as IDtoPeriod;
    public constructor(private configurationService: ConfigurationService
        , private formBuilder: FormBuilder
        , private configGeneral: AppConfig
        , private holidayService: HolidayService
        , private spinner: NgxSpinnerService
        , private securityService: SecurityService
        , private identityService: IdentityService
        , private customerService: CustomerService
        , private payrollService: PayrollService) {
        this.nav = document.querySelector('nav.navbar');
        this.initializeFormHoliday();
        this.showRoles = this.securityService.getUserRolesStorage();
        if (this.showRoles !== '') {
            this.employeeIniId = this.showRoles.employeeId;
            this.zones = this.showRoles.listZones === undefined ? [] : this.showRoles.listZones;
            this.marks = this.showRoles.listClients === undefined ? [] : this.showRoles.listClients;
        }
    }
    ngOnInit(): any {
        this.nav.className += ' white-bg';
        if (this.configurationService.isReady) {
            this.initialize();
            this.spinner.show();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.initialize();
                this.spinner.show();
            });
        }
    }
    private initialize(): void {
        this.getEmployeeData(this.employeeIniId);
        this.getCatalogEmployeesByFilter();
        this.getCatalogFederalHoliday();
        this.catalogTrademarks = this.customerService.getCatalogCustomers();
    }
    private getEmployeesByTrademark(dto: IDtoCatalog): void {
        this.employeeIniId = null;
        this.catalogEmployees = this.catalogEmployeesTemp.filter(e => e.additional == dto.id.toString());
    }
    private getCatalogEmployeesByFilter(): void {
        this.holidayService.getEmployeesByBoss(this.employeeIniId).subscribe(x => {
            this.catalogEmployeesTemp = x;
            this.catalogEmployees = x;
        })
    }
    private getCatalogFederalHoliday(): void {
        this.holidayService.getCatalogFederalHoliday().subscribe(x => {
            this.festiveDays = x;
        })
    }
    private initializeFormHoliday() {
        this.formHoliday = this.formBuilder.group({
            holidayPeriod: [null, Validators.required],
            comments: [null, [Validators.required, Validators.maxLength(500)]]
        });
    }
    public ngOnDestroy(): any {
        this.nav.classList.remove('white-bg');
    }
    private selectHoliday(values: Date[]): void {
        if (values !== null) {
            if (this.employee.availableDays === 0) {
                this.configGeneral.newToast('Validación', 'Usted no tiene dias disponibles para tomar vacaciones', 'warning');
                return;
            }
            this.eventFormatted = true;
            let initDate = new Date(values[0].getFullYear(),
                values[0].getMonth(),
                values[0].getDate(), 0, 0, 0, 0);

            let finalDate = new Date(values[1].getFullYear(),
                values[1].getMonth(),
                values[1].getDate(), 23, 59, 59, 0);
            const availableDays = 10;
            this.rangeHoliday = new HolidayRange(this.employee.nonWorkingDays, availableDays, initDate, finalDate, this.festiveDays);
            this.rangeHoliday.totalDays = this.rangeHoliday.differenceDateNum - this.rangeHoliday.discardedDays
            const availableDaysTmp = this.rangeHoliday.availableDays - this.rangeHoliday.totalDays;
            this.rangeHoliday.availableDays = !isNaN(availableDaysTmp) ? (availableDaysTmp >= 0 ? availableDaysTmp : 0) : 0;
            this.getDateRangeToString();
            if (this.rangeHoliday.totalDays > this.employee.availableDays) {
                this.configGeneral.newToast('Validación', 'Los dias seleccionados sobre pasan los disponibles', 'error');
            }
        }
    }
    private discard(): void {
        this.eventFormatted = false;
        this.rangeHoliday = new HolidayRange(null, 0, new Date(), new Date(), null);
        this.formHoliday.reset();
    }
    private getDateRangeToString(): void {
        this.rangeHoliday.listDiscardedDays.forEach((element) => {
            this.rangeHoliday.listDiscardedDaysToString.push(this.getLocaleDateString(element));
        });
    }
    private getLocaleDateString(date: any): string {
        const dt = new Date(date);
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        return dt.toLocaleDateString('es-MX', options);
    }
    private submitForm(): void {
        if (this.formHoliday.valid) {
            this.addSwal.title = 'El periodo vacacional seleccionado sera enviado a su jefe inmediato para su aprobación.';
            this.addSwal.show();
        } else {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'error');
            this.configGeneral.touchedControls(this.formHoliday);
        }
    }
    private save(): void {
        this.spinner.show();
        const holiday = {} as IDtoHoliday;
        holiday.employeeId = this.employeeIniId;
        holiday.employeeNum = this.employee.employeeNum;
        holiday.availableDays = this.employee.availableDays;
        holiday.employeeDate = this.employee.employeeDate;
        holiday.laborSeniorityDate = this.employee.laborSeniorityDate;
        holiday.initDate = this.configGeneral.getLocalISOTime(this.rangeHoliday.initDate);
        holiday.finalDate = this.configGeneral.getLocalISOTime(this.rangeHoliday.finalDate);
        holiday.totalDays = this.rangeHoliday.totalDays;
        holiday.comments = this.formHoliday.value.comments;
        holiday.createdDate = null;
        holiday.priorBalance = this.employee.availableDays;
        holiday.discardedDays = this.rangeHoliday.discardedDays;
        holiday.codeNomPayroll = this.employee.employeeTypePayrollId;
        holiday.codeNomcompanyPay = this.employee.employeeCompanyId;
        holiday.positionId = this.employee.employeePositionId;
        this.holidayService.addHoliday(holiday)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        this.getEmployeeData(this.employeeIniId);
                        let h = x.data as IDtoHoliday
                        this.addModuleLog(h.id);
                        this.formHoliday.reset();
                    } else
                    {
                        this.spinner.hide();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }

    private getEmployeeData(id: string): void {
        this.spinner.show();
        this.eventFormatted = false;
        this.formHoliday.reset();
        this.holidayService.getEmployeeData(id).subscribe((res) => {
            this.employee = res.data as IDtoEmployee;
            const availableDays = this.employee.availableDays == null ? 0 : this.employee.availableDays;
            this.rangeHoliday = new HolidayRange(this.employee.nonWorkingDays, availableDays, new Date(), new Date(), this.festiveDays);
            this.getHolidayRequestsByEmployeeId(id, this.employee.requisitionId);
            this.getHolidayLaborOldByEmployeeId(id);
            this.getLastActivePeriod(this.employee);
            this.spinner.hide();
        });
    }
    private getLastActivePeriod(dto: IDtoEmployee): void {
      const date: Date = new Date();
      this.payrollService.getLastActivePeriod(dto.employeeCompanyId, dto.payrollTypeId.toString().padStart(5, '0') ).subscribe((res) => {
          this.period = res.data as IDtoPeriod;
          if(this.period.status == 'Cerrada')
          this.minDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        else{
          this.minDate = new Date(this.period.initDate);
        }
      });
    }

    private getHolidayRequestsByEmployeeId(id: string, requisitionId: number): void {
        this.holidayService.getHolidayRequestsByEmployeeId(id, requisitionId).subscribe((res) => {
            this.listHolidayRequests = res.data as IDtoHoliday[];
        });
    }
    private getHolidayLaborOldByEmployeeId(id: string): void {
        this.holidayService.getHolidayLaborOldByEmployeeId(id).subscribe((res) => {
            this.listHolidayLaborOlds = res.data as IDtoHistory[];
        });
    }
    private addModuleLog(id: number): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Holidays';
        dto.module = 'holidayRequest';
        dto.action = 'new';
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
}
